import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Location, InfoStroke, ArrowL } from '../Icons/CustomIcons';

export function LoginBack({ returnTo = '/' }) {
  const navigate = useNavigate();
  return (
    <div>
      <button
        type="button"
        className="auth-fullpage-back-btn"
        onClick={() => navigate(returnTo)}
        aria-label="Zurück"
      >
        <ArrowL size={20} aria-hidden="true" />
      </button>
      <Link
        to="/"
        className="auth-fullpage-logo"
        aria-label="Zur Startseite"
      >
        <img src="/logo-mobile.svg" className="header-logo-img" alt="grosskinder-aktiv.ch" />
      </Link>
    </div>
  );
}

export function LoginHeader({
  title = 'Konto erstellen oder anmelden',
  subtitle = 'Melden Sie sich an, um Aktivitäten einzugeben und Ihre eingegebenen Aktivitäten anzuschauen',
}) {
  return (
    <div className="auth-fullpage-hero">
      <h1 className="headings Font-H0-A-120-T auth-fullpage-hero-title">{title}</h1>
      <p className="body Font-M-B-130-T auth-fullpage-hero-subtitle">{subtitle}</p>
    </div>
  );
}

export function Advice({ text, children }) {
  return (
    <div className="advice-box">
      <p className="body-s line-height-default letter-spacing-tight body--medium Color-Black">
        <InfoStroke style={{ flexShrink: 0, marginTop: '2px' }} color="var(--Colors-Accent-01)" />
        {text ?? children}
      </p>
    </div>
  );
}

export const Card = ({ children, className = '', onClick }) => {
  return (
    <div 
      className={`card ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export function LocationBox({ locationName }) {
  if (!locationName) return null;
  return (
    <div className="location-box">
      <span className="body Font-L-S-130-T Colors-Black location-name">
        <span className="location-icon">
          <Location size={20} color="var(--Colors-White)" />
        </span>
        {locationName}
      </span>
      <span className="body Font-S-B-130-T Colors-Grey-06 location-label">Ortsbezeichnung</span>
    </div>
  );
}
